<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <v-alert
          v-for="(item, index) in updateErrors"
          :key="index"
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
        >
          {{ item[0] }}
        </v-alert>
        <v-text-field
          v-model="unit"
          outlined
          dense
          hide-details="auto"
          label="Unit"
        />
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="description"
          outlined
          dense
          hide-details="auto"
          label="Description"
        />
      </v-col>
      <v-col
        cols="6"
      >
        <v-btn
          color="primary"
          block
          :loading="updating"
          @click="initUpdate"
        >
          <v-icon left>
            mdi-content-save
          </v-icon>
          Save
        </v-btn>
      </v-col>
      <v-col
        cols="6"
      >
        <v-btn
          color="grey darken-1"
          dark
          block
          @click="closeDialog"
        >
          Close
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'VUnitEdit',
    props: {
      propUnitId: {
        type: Number,
        default: null,
      },
      propUnitData: Object,
    },
    data () {
      return {
        unit: null,
        description: null,
      }
    },
    computed: {
      ...mapState({
        updating: state => state.unit.updating,
        updateErrors: state => state.unit.updateErrors,
        updateSuccess: state => state.unit.updateSuccess,
      }),
      unitId () {
        // this.unitIdSideEffects()
        return this.propUnitId
      },
    },
    watch: {
      updateSuccess (val) {
        if (val) {
          this.resetData()
          this.closeDialog()
        }
      },
      propUnitId (val) {
        this.unitIdSideEffects()
      },
    },
    methods: {
      ...mapActions({
        update: 'unit/update',
      }),
      resetData () {
        this.unit = null
        this.description = null
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
      unitIdSideEffects () {
        this.unit = this.propUnitData.unit
        this.description = this.propUnitData.description
      },
      initUpdate () {
        const data = {
          unit: this.unit,
          description: this.description,
        }
        this.update({
          data,
          id: this.unitId,
        })
      },
    },
  }
</script>
